import React from 'react';
import { CallMetric } from '../../types/dashboard';
import { Phone, PhoneIncoming, PhoneOutgoing, PhoneMissed } from 'lucide-react';
interface CallActivityChartProps {
  data: CallMetric[];
}
export function CallActivityChart({
  data
}: CallActivityChartProps) {
  // Simple bar chart implementation using flexbox/grid since we don't have a charting library
  const maxVal = Math.max(...data.map(d => d.inbound + d.outbound + d.missed));
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-30">
      <div className="flex justify-between items-center mb-6" data-id="element-31">
        <h3 className="font-bold text-slate-800 flex items-center gap-2" data-id="element-32">
          <Phone className="w-5 h-5 text-blue-600" data-id="element-33" />
          Live Call Activity
        </h3>
        <div className="flex gap-4 text-xs" data-id="element-34">
          <div className="flex items-center gap-1" data-id="element-35">
            <div className="w-3 h-3 bg-blue-500 rounded-sm" data-id="element-36"></div> Inbound
          </div>
          <div className="flex items-center gap-1" data-id="element-37">
            <div className="w-3 h-3 bg-emerald-500 rounded-sm" data-id="element-38"></div> Outbound
          </div>
          <div className="flex items-center gap-1" data-id="element-39">
            <div className="w-3 h-3 bg-rose-500 rounded-sm" data-id="element-40"></div> Missed
          </div>
        </div>
      </div>

      <div className="h-48 flex items-end justify-between gap-2" data-id="element-41">
        {data.map((item, i) => {
        const total = item.inbound + item.outbound + item.missed;
        const inboundHeight = item.inbound / maxVal * 100;
        const outboundHeight = item.outbound / maxVal * 100;
        const missedHeight = item.missed / maxVal * 100;
        return <div key={i} className="flex-1 flex flex-col items-center group" data-id="element-42">
              <div className="w-full max-w-[40px] flex flex-col-reverse h-full relative" data-id="element-43">
                {/* Tooltip */}
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-slate-800 text-white text-xs p-2 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 w-32" data-id="element-44">
                  <div className="font-bold mb-1" data-id="element-45">{item.time}</div>
                  <div className="flex justify-between" data-id="element-46">
                    <span data-id="element-47">In:</span> <span data-id="element-48">{item.inbound}</span>
                  </div>
                  <div className="flex justify-between" data-id="element-49">
                    <span data-id="element-50">Out:</span> <span data-id="element-51">{item.outbound}</span>
                  </div>
                  <div className="flex justify-between text-rose-300" data-id="element-52">
                    <span data-id="element-53">Missed:</span> <span data-id="element-54">{item.missed}</span>
                  </div>
                </div>

                {/* Bars */}
                <div className="w-full bg-blue-500 rounded-t-sm transition-all hover:bg-blue-400" style={{
              height: `${inboundHeight}%`
            }} data-id="element-55" />
                <div className="w-full bg-emerald-500 transition-all hover:bg-emerald-400" style={{
              height: `${outboundHeight}%`
            }} data-id="element-56" />
                <div className="w-full bg-rose-500 rounded-b-sm transition-all hover:bg-rose-400" style={{
              height: `${missedHeight}%`
            }} data-id="element-57" />
              </div>
              <span className="text-xs text-slate-400 mt-2 font-mono" data-id="element-58">
                {item.time}
              </span>
            </div>;
      })}
      </div>

      <div className="mt-4 grid grid-cols-3 gap-4 pt-4 border-t border-slate-100" data-id="element-59">
        <div className="text-center" data-id="element-60">
          <div className="text-xs text-slate-500 mb-1 flex items-center justify-center gap-1" data-id="element-61">
            <PhoneIncoming className="w-3 h-3" data-id="element-62" /> Total Inbound
          </div>
          <div className="text-xl font-bold text-slate-800" data-id="element-63">180</div>
        </div>
        <div className="text-center" data-id="element-64">
          <div className="text-xs text-slate-500 mb-1 flex items-center justify-center gap-1" data-id="element-65">
            <PhoneOutgoing className="w-3 h-3" data-id="element-66" /> Total Outbound
          </div>
          <div className="text-xl font-bold text-slate-800" data-id="element-67">138</div>
        </div>
        <div className="text-center" data-id="element-68">
          <div className="text-xs text-slate-500 mb-1 flex items-center justify-center gap-1" data-id="element-69">
            <PhoneMissed className="w-3 h-3 text-rose-500" data-id="element-70" /> Missed Rate
          </div>
          <div className="text-xl font-bold text-rose-600" data-id="element-71">4.2%</div>
        </div>
      </div>
    </div>;
}